import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api } from '@saucelabs/sl-module-performance';

import * as types from './types';

export const updateSelectedTestPageInfo = createAction(types.UPDATE.SELECTED_TEST_PAGE_INFO);
export const updateSelectedMetrics = createAction(types.UPDATE.SELECTED_METRICS);
export const updateSelectedBaselineChartDataPoint = createAction(
  types.UPDATE.SELECTED_BASELINE_CHART_DATA_POINT);
export const fetchSelectedBaselineJobDataRequest = createAction(
  types.GET_SELECTED_BASELINE_JOB_DATA.REQUEST);
export const fetchSelectedBaselineJobDataSuccess = createAction(
  types.GET_SELECTED_BASELINE_JOB_DATA.SUCCESS);
export const fetchSelectedBaselineJobDataFailure = createAction(
  types.GET_SELECTED_BASELINE_JOB_DATA.FAILURE);
export const cleanup = createAction(types.CLEANUP);
export const updatePerfType = createAction(types.UPDATE.PERF_TYPE);

export const fetchMetricsHistory = createApiAction(
  types.GET_METRICS_HISTORY,
  (payload) => api.fetchMetricsHistory(payload),
);

export const fetchJobData = createApiAction(
  types.GET_JOB_DATA,
  (payload) => api.fetchJobData(payload),
);

export const fetchSelectedBaselineJobData = (payload) => (dispatch) => {
  const { auth, jobId, selectedJobInfo, timestamp, perfType } = payload;
  dispatch(fetchSelectedBaselineJobDataRequest());
  return api.fetchJobData({ auth, jobId })
    .then(({ data: { items: jobData } }) => {
      const pageUrl = selectedJobInfo.get('pageUrl');
      const jobInfo = jobData.find(({ page_url: jobPageUrl }) => pageUrl === jobPageUrl);
      if (!jobInfo) {
        throw new Error('We are unable to fetch metrics for the selected data point.');
      }
      return dispatch(fetchSelectedBaselineJobDataSuccess({
        ...jobInfo, timestamp, perfType,
      }));
    })
    .catch((error) => {
      dispatch(fetchSelectedBaselineJobDataFailure(error));
    });
};
